import { createContext } from 'react';

export type BreadcrumbsSize = 'default' | 'heading';
export type BreadcrumbsEmphasis = 'default' | 'subtle';

export interface BreadcrumbsContextType {
  size: BreadcrumbsSize;
  emphasis: BreadcrumbsEmphasis;
}

export const BreadcrumbsContext = createContext<BreadcrumbsContextType>({
  size: 'default',
  emphasis: 'default',
});

BreadcrumbsContext.displayName = 'BreadcrumbsContext';
